module.exports = __webpack_public_path__ + "img/receiptLotteryLose@3x.d8358fb9.png";